module.exports = __webpack_public_path__ + "static/media/Espiral.ed062b91.png";